module.exports = __webpack_public_path__ + "static/media/lysaght_terms.a37e149f.pdf";